// extracted by mini-css-extract-plugin
module.exports = {"map":"MapSection_map__dO2qQ","popup":"MapSection_popup__YaL_h","content":"MapSection_content__2V4Pf","btn":"MapSection_btn__lLwYM"};